export const usMenus = (logoUrl) => ({
    type: 'public',
    logoItems: [
        {
            id: '2b38e7ec-e2ff-4765-8190-5408dfd356df',
            href: '/en-us/',
            url: logoUrl,
            alt: 'Raisin',
        },
    ],
    navItems: [
        {
            id: '5523f9f0-ff49-4402-b9ca-2d08f048cafa',
            title: 'Quick Start',
            href: '/en-us/how-to-register',
            subMenus: {
                main: [
                    {
                        id: 'd08f467e-2331-402d-b1bb-ee327e4c3680',
                        type: 'text',
                        title: 'How it Works',
                        href: '/en-us/how-it-works/',
                    },
                    {
                        id: 'e276dbab-6f13-4638-9e57-6fc6b9315307',
                        type: 'text',
                        title: 'How to Register',
                        href: '/en-us/how-to-register/',
                    },
                    {
                        id: 'e1e7d66b-a3ff-4817-89db-86f6cfff3dda',
                        type: 'text',
                        title: 'Getting Started',
                        href: '/en-us/getting-started-with-raisin/',
                    },
                    {
                        id: '7bdd93af-17cb-4244-a4cd-df09a70721b9',
                        type: 'text',
                        title: 'Save with Purpose',
                        href: '/en-us/save-with-purpose/',
                    },
                ],
            },
        },
        {
            id: 'u7u7i7d7-3a9f-44e3-a75e-testID345678',
            title: 'Products',
            href: '/en-us/explore-products/',
            subMenus: {
                main: [
                    {
                        id: '911a8eea-5374-4509-9ee3-16abd0f1cac9',
                        type: 'advanced',
                        title: 'Savings Accounts',
                        href: '/en-us/savings-accounts/',
                        icon: 'percentIcon',
                        iconColor: '#9DD3E4',
                    },
                    {
                        id: 'f7f7a630-9026-485b-a487-ab90b558d326',
                        type: 'advanced',
                        title: 'Money Market Accounts',
                        href: '/en-us/money-market-accounts/',
                        icon: 'overnightMoneyIcon',
                        iconColor: '#7EBDD9',
                    },
                    {
                        id: 'cbfa8440-765b-4034-948a-d7f972612429',
                        type: 'advanced',
                        title: 'CD Accounts',
                        href: '/en-us/cd-accounts/',
                        icon: 'fixedDepositIcon',
                        iconColor: '#327EA6',
                    },
                    {
                        id: '2f1eb368-40cc-4a51-a900-e9879268f9b3',
                        type: 'advanced',
                        title: 'No-Penalty CDs',
                        href: '/en-us/cd-accounts/no-penalty-cd-rates/',
                        icon: 'trendingUpIcon',
                        iconColor: '#FBC02D',
                    },
                    {
                        id: '74bd7e11-9104-44ef-aeee-a2b425bbdf0e',
                        type: 'advanced',
                        title: 'All Products',
                        href: '/en-us/explor-products/',
                        icon: 'pagesIcon',
                        iconColor: '#FFB301',
                    },
                ],
            },
        },
        {
            id: '4e401f98-fea0-4f02-b65d-e7931303f094',
            title: 'About',
            href: '/en-us/about-us',
            subMenus: {
                main: [
                    {
                        id: '6b86e922-27fd-4de1-ac57-ec366d965b02',
                        type: 'advanced',
                        title: 'About Raisin',
                        href: '/en-us/about-us/',
                        icon: 'infoIcon',
                        iconColor: '#0E6CC5',
                    },
                    {
                        id: '9738ea93-c58d-43e8-95a4-c37dd9442b9f',
                        type: 'advanced',
                        title: 'Our Partner Banks',
                        href: '/en-us/banks/',
                        icon: 'taxIcon',
                        iconColor: '#0E6CC5',
                    },
                    {
                        id: '3408b28e-77c3-4549-8e8b-a8b0bbfca016',
                        type: 'advanced',
                        title: 'Our Partner Credit Unions',
                        href: '/en-us/credit-unions/',
                        icon: 'partnerIcon',
                        iconColor: '#0E6CC5',
                    },
                    {
                        id: '681209a8-1086-40ba-976d-a56055845cf6',
                        type: 'advanced',
                        title: 'Banks vs Credit Unions',
                        href: '/en-us/credit-unions-vs-banks/',
                        icon: 'compareIcon',
                        iconColor: '#0E6CC5',
                    },
                    {
                        id: 'b16186a6-a6e4-4f06-8ce7-68fe879b6891',
                        type: 'advanced',
                        title: 'Deposit Insurance',
                        href: '/en-us/deposit-insurance/',
                        icon: 'moneyIcon',
                        iconColor: '#0E6CC5',
                    },
                ],
            },
        },
        {
            id: '26260945-75a8-4987-90a9-abbbbe53b5df',
            title: 'Help & Info',
            href: 'https://support.raisin.com/hc/en-us/',
            subMenus: {
                main: [
                    {
                        id: '541f36e4-8e42-45df-87da-04e5caec5188',
                        type: 'text',
                        title: 'FAQ',
                        href: 'https://support.raisin.com/hc/en-us/',
                    },
                    {
                        id: '26944a6e-7453-4d12-96f5-51cdfe0d2d8b',
                        type: 'text',
                        title: 'Education Center',
                        href: '/en-us/education-center',
                    },
                    {
                        id: '15ccd86c-6a21-4cd6-802d-277db0799a0a',
                        type: 'text',
                        title: 'Savings Guides',
                        href: '/en-us/savings/',
                    },
                    {
                        id: 'e0b2b941-850a-47e0-90cf-8e1cd4e63072',
                        type: 'text',
                        title: 'Banking Guides',
                        href: '/en-us/banking/',
                    },
                    {
                        id: 'd74f4c3d-5fd4-4b31-a371-b60e88e6d296',
                        type: 'text',
                        title: 'Refer a Friend',
                        href: '/en-us/refer-a-friend/',
                    },
                ],
            },
        },
    ],
    actionItems: [
        {
            id: '81752542-171b-4500-8ad7-e1720d33e633',
            title: 'Log In',
            href: 'https://app.raisin.com/en-us/auth/login/',
            type: 'login',
        },
        {
            id: '21c00ccf-32ed-45a9-8d34-52ce3acb4bd3',
            title: 'Get Started',
            href: 'https://app.raisin.com/en-us/auth/register/',
            type: 'registration',
        },
    ],
});
//# sourceMappingURL=usMenus.js.map